import { Field, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { File } from '../file/File'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('EmailCommunicationInput')
export class EmailCommunication {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('eml') })
  _id: string

  @Field(() => String)
  @Prop({ type: String })
  to: string

  @Field(() => String)
  @Prop({ type: String })
  from: string

  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date

  @Field(() => String)
  @Prop({ type: String })
  content: string

  @Field(() => [File])
  @Prop({ type: [File] })
  attachments: File[]
}
